import { render, staticRenderFns } from "./gravy_items.vue?vue&type=template&id=5ed29c27"
import script from "./gravy_items.vue?vue&type=script&lang=js"
export * from "./gravy_items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports